module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114138_99_157.85543ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114138_99_157.jpg
// module id = o8+Z
// module chunks = 0